import { ConfigService } from './config.service';

export function initConfig(config: ConfigService) {
  return () => config.load();
}
